import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import ConfirmDeleteDialog from '../../../security/ConfirmDeleteDialog';
import Modal from '../Gestion/ChoferVehiculoAsignado/ChoferVehiculoAsignadoModalTab';
import { ENDPOINTS } from '../../Utils/Endpoints';
import { Models } from '../../Utils/ModelsCarBooking';
import sigmaEdit from '../../../Pages/img/Editar.png';
import sigmaDelete from '../../../Pages/img/Borrar.png';

const TITLETAB = 'Vehículo Asignado';
const idKey = 'idAsignacion';
const fkKey = 'idChofer';

const endpoint = ENDPOINTS.choferVehiculoAsignacion;
const endpointById = ENDPOINTS.choferVehiculoAsignacionById;
const normalize = Models.choferVehiculoAsignacion;

const endpointVehiculos = ENDPOINTS.vehiculo;
const modeloVehiculo = Models.vehiculo;

const PAGE = 5;

export default function ChoferVehiculoAsignadoTab({ fkValue }) {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [query, setQuery] = useState('');
    const [formOpen, setFormOpen] = useState(false);
    const [formMode, setFormMode] = useState('new');
    const [selectedId, setSelectedId] = useState(null);
    const [editData, setEditData] = useState(null);

    const [deleteOpen, setDeleteOpen] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState({ id: 0, name: '' });

    const [page, setPage] = useState(1);

    const load = async () => {
        setLoading(true);
        try {
            const [resRel, resVehs] = await Promise.all([
                axios.get(endpoint),
                axios.get(endpointVehiculos),
            ]);

            let arr = (resRel?.data || []).map(normalize);
            const vehiculos = (resVehs?.data || []).map(modeloVehiculo);

            // Enriquecer
            arr = arr.map((rel) => {
                const veh = vehiculos.find(v => v.idVehiculo === rel.idVehiculo);
                console.log(veh)
                const nombreVehiculo = veh
                    ? `${veh.marca} ${veh.modelo} (${veh.placa})`
                    : `Vehículo #${rel.idVehiculo}`;

                return {
                    ...rel,
                    nombreVehiculo,
                };
            });

            setRows(arr);
        } catch (e) {
            console.error(e);
            alert(`Error al cargar ${TITLETAB}`);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (fkValue) load();
    }, [fkValue]);

    const filtered = useMemo(() => {
        let res = rows;
        // Filtrar por FK (Chofer)
        if (fkValue) {
            res = res.filter(r => Number(r.idChofer) === Number(fkValue));
        }
        // Filtrar por texto
        const q = query.trim().toLowerCase();
        if (q) {
            res = res.filter(r =>
                (r.nombreVehiculo || '').toLowerCase().includes(q) ||
                (r.comentarios || '').toLowerCase().includes(q)
            );
        }
        return res;
    }, [rows, fkValue, query]);

    const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE));
    useEffect(() => { if (page > totalPages) setPage(1); }, [totalPages, page]);

    const paged = useMemo(() => {
        const start = (page - 1) * PAGE;
        return filtered.slice(start, start + PAGE);
    }, [filtered, page]);

    const onNew = () => {
        setFormMode('new');
        setSelectedId(null);
        setEditData(null);
        setFormOpen(true);
    };

    const onEdit = (id) => {
        setFormMode('edit');
        setSelectedId(id);
        const row = rows.find(r => r[idKey] === id);
        setEditData(row);
        setFormOpen(true);
    };

    const onAskDelete = (row) => {
        setDeleteTarget({ id: row[idKey], name: row.nombreVehiculo });
        setDeleteOpen(true);
    };

    const onConfirmDelete = async () => {
        try {
            setLoading(true);
            await axios.delete(endpointById(deleteTarget.id));
            setDeleteOpen(false);
            await load();
        } catch (e) {
            console.error(e);
            alert('No se pudo eliminar.');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmitFromModal = async (formData, mode) => {
        try {
            setLoading(true);
            const payload = {
                ...formData,
                idChofer: Number(fkValue),
            };

            if (mode === 'new') {
                await axios.post(endpoint, payload);
            } else {
                await axios.put(endpoint, payload);
            }

            setFormOpen(false);
            await load();
        } catch (e) {
            console.error(e);
            alert('No se pudo guardar.');
        } finally {
            setLoading(false);
        }
    };

    const PageBtn = ({ label, onClick, active, disabled }) => (
        <button
            className={`roles-page-btn ${active ? 'is-active' : ''} ${disabled ? 'is-disabled' : ''}`}
            onClick={onClick}
            disabled={disabled}
            type="button"
        >
            {label}
        </button>
    );

    const pages = (() => {
        const maxToShow = 5;
        let start = Math.max(1, page - 2);
        let end = Math.min(totalPages, start + maxToShow - 1);
        start = Math.max(1, end - maxToShow + 1);
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    })();

    return (
        <div className="mini-crud">
            <div className="mini-topbar">
                <h3 className="roles-title" style={{ margin: 0 }}>{TITLETAB}</h3>
                <div style={{ display: 'flex', gap: 8 }}>
                    <input
                        className="roles-search"
                        placeholder="Buscar vehículo..."
                        value={query}
                        onChange={(e) => { setQuery(e.target.value); setPage(1); }}
                    />
                    <button className="btn-action" onClick={onNew}>＋ Nuevo</button>
                </div>
            </div>

            <div className="roles-table-wrap">
                <div className="roles-table-scroller">
                    <table className="roles-table">
                        <thead>
                            <tr>
                                <th>Vehículo</th>
                                <th>Desde</th>
                                <th>Hasta</th>
                                <th>Comentarios</th>
                                <th style={{ textAlign: 'center' }}>Editar</th>
                                <th style={{ textAlign: 'center' }}>Borrar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paged.map((row) => (
                                <tr key={row[idKey]}>
                                    <td>{row.nombreVehiculo}</td>
                                    <td>{row.fechaDesde ? new Date(row.fechaDesde).toLocaleString() : ''}</td>
                                    <td>{row.fechaHasta ? new Date(row.fechaHasta).toLocaleString() : '-'}</td>
                                    <td>{row.comentarios}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        <button type="button" className="rk-iconbtn rk-iconbtn--edit" onClick={() => onEdit(row[idKey])}>
                                            <img src={sigmaEdit} alt="" className="rk-ico" />
                                        </button>
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <button type="button" className="rk-iconbtn rk-iconbtn--del" onClick={() => onAskDelete(row)}>
                                            <img src={sigmaDelete} alt="" className="rk-ico" />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            {!loading && paged.length === 0 && (
                                <tr><td colSpan={6}>Sin resultados.</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="roles-pagination" style={{ marginTop: 8 }}>
                <div />
                <div className="roles-pagination-right">
                    <PageBtn label="‹" onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1} />
                    {pages.map((n) => (<PageBtn key={n} label={n} onClick={() => setPage(n)} active={n === page} />))}
                    <PageBtn label="›" onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={page === totalPages} />
                </div>
            </div>

            {formOpen && (
                <Modal
                    open={formOpen}
                    mode={formMode}
                    data={editData}
                    fkValue={fkValue}
                    onClose={() => setFormOpen(false)}
                    onSubmit={handleSubmitFromModal}
                />
            )}

            <ConfirmDeleteDialog
                open={deleteOpen}
                roleName={deleteTarget.name}
                onClose={() => setDeleteOpen(false)}
                onConfirm={onConfirmDelete}
            />
        </div>
    );
}
